import React from 'react';
import { Global } from '@emotion/react';

import fonts from './fonts';
import cssReset from './cssReset';
import animations from './animations';
import base from './base';

const GlobalStyles = () => (
    <>
        <Global styles={fonts} />
        <Global styles={cssReset} />
        <Global styles={animations} />
        <Global styles={base} />
    </>
);

export default GlobalStyles;
